<template>
  <div>
    <b-sidebar
      id="sidebar-kpi-filters"
      sidebar-class="sidebar-lg"
      :visible="visible"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @change="(val) => $emit('update:visible', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h4>Filtros</h4>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Form -->
        <b-form class="p-2" @submit.prevent="onSave">
          <b-form-group label="Valores" label-for="sidebarContractStatus" class="mt-1 mb-3">
            <b-form-radio-group
              id="sidebarContractStatus"
              v-model="localContractStatus"
              stacked
            >
              <b-form-radio class="mt-1" value="gross">Brutos</b-form-radio>
              <b-form-radio class="mt-1" value="valid">Validados</b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <b-form-group label="Modo" label-for="sidebarSnapshotMode" class="mt-1 mb-3">
            <b-form-radio-group
              id="sidebarSnapshotMode"
              v-model="localSnapshotMode"
              stacked
            >
              <b-form-radio class="mt-1" value="live">Live</b-form-radio>
              <b-form-radio class="mt-1" value="snapshot">Materializado</b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <b-form-group class="mt-1">
            <b-form-checkbox v-model="localAllConsultants" switch>
              Incluir PNs out
            </b-form-checkbox>
          </b-form-group>

          <b-form-group class="mt-1">
            <b-form-checkbox v-model="localIncludeInactiveFranchises" switch>
              Incluir franqueados desativados
            </b-form-checkbox>
          </b-form-group>

          <b-form-group class="mt-1">
            <b-form-checkbox v-model="localIncludeInactiveNetworks" switch>
              Incluir redes desativadas
            </b-form-checkbox>
          </b-form-group>

          <b-form-group class="mt-1">
            <b-form-checkbox v-model="localDisableContractNetworks" switch>
              Desabilitar verificações de redes de contrato
            </b-form-checkbox>
          </b-form-group>

          <b-form-group class="mt-1">
            <b-form-checkbox v-model="localIncludeEmployees" switch>
              Incluir colaboradores
            </b-form-checkbox>
          </b-form-group>

          <!-- Actions -->
          <div class="d-flex mt-3">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
            >
              Salvar filtros
            </b-button>
          </div>
        </b-form>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormRadio,
  BFormRadioGroup,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormRadio,
    BFormRadioGroup,
    BFormCheckbox,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    contractStatus: {
      type: String,
      default: "valid",
    },
    allConsultants: {
      type: Boolean,
      default: false,
    },
    includeInactiveFranchises: {
      type: Boolean,
      default: false,
    },
    includeInactiveNetworks: {
      type: Boolean,
      default: false,
    },
    disableContractNetworks: {
      type: Boolean,
      default: false,
    },
    includeEmployees: {
      type: Boolean,
      default: false,
    },
    snapshotMode: {
      type: String,
      default: 'live',
    },
  },
  data() {
    return {
      localContractStatus: this.contractStatus,
      localSnapshotMode: this.snapshotMode,
      localAllConsultants: this.allConsultants,
      localIncludeInactiveFranchises: this.includeInactiveFranchises,
      localIncludeInactiveNetworks: this.includeInactiveNetworks,
      localDisableContractNetworks: this.disableContractNetworks,
      localIncludeEmployees: this.includeEmployees,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.localContractStatus = this.contractStatus;
        this.localSnapshotMode = this.snapshotMode;
        this.localAllConsultants = this.allConsultants;
        this.localIncludeInactiveFranchises = this.includeInactiveFranchises;
        this.localIncludeInactiveNetworks = this.includeInactiveNetworks;
        this.localDisableContractNetworks = this.disableContractNetworks;
        this.localIncludeEmployees = this.includeEmployees;
      }
    },
  },
  methods: {
    onSave() {
      this.$emit("save", {
        contractStatus: this.localContractStatus,
        snapshotMode: this.localSnapshotMode,
        allConsultants: this.localAllConsultants,
        includeInactiveFranchises: this.localIncludeInactiveFranchises,
        includeInactiveNetworks: this.localIncludeInactiveNetworks,
        disableContractNetworks: this.localDisableContractNetworks,
        includeEmployees: this.localIncludeEmployees,
      });
      this.$emit("update:visible", false);
    },
  },
};
</script>
